<template>
  <div>
    <Nav/>
    <PageBannerSmall :banner="banner"></PageBannerSmall>
    <Contacts/>
    <Contact/>
    <Footer/>
  </div>
</template>

<script>
import Nav from '@/components/Nav'
import PageBannerSmall from '@/components/PageBannerSmall'
import Contacts from '@/components/Contacts'
import Contact from '@/components/Contact'
import Footer from '@/components/Footer'
export default {
  name: '',
  components: {
    Nav,
    PageBannerSmall,
    Contacts,
    Contact,
    Footer
  },
  data () {
    return {
      banner: {
        img: require("@/assets/img/contacts-banner.jpg"),
        title: "感动常在",
        sub: "诚心诚意为顾客提供专业、优质的服务。"
      }
    }
  }
}
</script>

<style scoped lang="less">
</style>